/* @flow */
import { tablet } from '@braindate/ui/lib/token/mediaQuery';
import { baseFontSize } from '@braindate/ui/lib/token/typography';
import { em } from 'polished';

export default {
  root: {
    paddingRight: 12,
  },
  title: {
    marginTop: 8,

    [tablet]: {
      display: 'none',
    },
  },
  emptyInterests: {
    display: 'flex',
    marginTop: 12,
  },
  skeletons: {
    display: 'flex',
    gap: em(10, baseFontSize),
  },
};
